/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Scene_Description_Job_Archived_SuccessInputs */



/**
* | output |
* | --- |
* | "Shot description job archived successfully." |
*
* @param {Scene_Description_Job_Archived_SuccessInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const scene_description_job_archived_success = /** @type {((inputs?: Scene_Description_Job_Archived_SuccessInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Scene_Description_Job_Archived_SuccessInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Description du plan archivée avec succès.")
	if (locale === "de") return /** @type {LocalizedString} */ ("Auftragsbeschreibung erfolgreich archiviert.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Descrizione dell'inquadratura archiviata con successo.")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Задание по описанию кадра успешно завершено.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Descripción de la toma archivada con éxito.")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("镜头描述任务已成功存档。")
	if (locale === "ja") return /** @type {LocalizedString} */ ("撮影内容の説明が正常にアーカイブされました。")
	if (locale === "hi") return /** @type {LocalizedString} */ ("शॉट विवरण कार्य सफलतापूर्वक संग्रहीत हो गया।")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Tarefa de descrição da cena arquivada com sucesso.")
	return /** @type {LocalizedString} */ ("Shot description job archived successfully.")
});